<template>
    <div class="main_container" style="overflow: initial;">
        <el-tabs class="statistics_container" v-model="activeName">
            <el-tab-pane :key="index" :label="tab.SupplierName" :name="'statistics_' + index"
                         v-for="(tab, index) in tabLists">
                <statistics-panel :SupplierId="tab.Id" v-if="activeName === 'statistics_' + index"></statistics-panel>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import {GetSupplier} from "../api/apiStatistics";
    import StatisticsPanel from "../components/statisticsPanel";

    export default {
        name: 'statistics',
        components: {StatisticsPanel},
        data() {
            return {
                activeName: 'statistics_0',
                tabLists: []
            }
        },
        created() {
            this.getLanguageResourceForPage();
            this.initData();
        },
        mounted() {
        },
        computed: {},
        watch: {},
        methods: {
            async initData() {
                try {
                    this.getSupplier();
                } catch (err) {
                    console.log(err);
                }
            },
            // 获取供应商信息
            async getSupplier() {
                this.tabLists = [];
                try {
                    let data = await GetSupplier();
                    if (data.error_code === '0') {
                        this.tabLists = data.data;
                    }
                } catch (error) {
                    console.log(error);
                }
            },
        }
    }
</script>

<style scoped>

</style>
